import { render, staticRenderFns } from "./AgeReport.vue?vue&type=template&id=6f4ad32a"
import script from "./AgeReport.vue?vue&type=script&lang=js"
export * from "./AgeReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports